// src/components/Sidebar/SidebarSkeleton.jsx
import React, { memo } from "react";

function SidebarSkeleton({ rows = 6 }) {
  return (
    <div className="Sidebar-skel-list" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={`sidebar-skel-${i}`} className="Sidebar-skel-row">
          <div className="Sidebar-sidebar-skel Sidebar-skel-text" />
          <div className="Sidebar-sidebar-skel Sidebar-skel-badge" />
        </div>
      ))}
    </div>
  );
}

export default memo(SidebarSkeleton);
